export const SET_RATES_VARIABLES_PAYLOAD             = "SET_RATES_VARIABLES_PAYLOAD"; 
export const SET_VARIABLE_FIELD="SET_VARIABLE_FIELD";
export const SET_AUTO_MAPPING_FIELD="SET_AUTO_MAPPING_FIELD";
export const SET_AUTO_MAPPING_FILTERED_FIELD="SET_AUTO_MAPPING_FILTERED_FIELD"
export const SET_MAPPING_FIELD_DATA="SET_MAPPING_FIELD_DATA"
export const SET_FORMULA_FIELD_DATA="SET_FORMULA_FIELD_DATA"